import { eTipoPermissao } from '@/enums/ePermissoes';
export default [
    {
        description: 'Entidade',
        path: '/biblioteca/bibentidade',
        name: 'bibentidade',
        component: () => import('@/views/biblioteca/bibentidade/Index.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_ENTIDADENOVO_MENU_1300800699],
        },
        goesToMenu: true,
    },
    {
        description: 'Cadastro de Entidades',
        path: '/biblioteca/bibentidade/cadastro/:id?',
        parent: 'bibentidade',
        name: 'bibentidade_create',
        component: () => import('@/views/biblioteca/bibentidade/InclusaoEdicao.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_ENTIDADENOVO_MENU_1300800699],
        },
        goesToMenu: true,
    },
]
